import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';

import { BehaviourListModel } from '../../../../../../../core/models/common.models';

@Component({
  selector: 'app-define-behavior-wizard-frequency-step',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzRadioModule,
    NzDividerModule,
  ],
  templateUrl: './define-behavior-wizard-frequency-step.component.html',
  styleUrl: './define-behavior-wizard-frequency-step.component.scss',
})
export class DefineBehaviorWizardFrequencyStepComponent {
  @Input() form!: FormGroup;
  @Input() isRequired = false;
  @Input() behaviourFrequencyList: BehaviourListModel[] = [];
  @Input() getBehaviorFrequencyLabel!: (name: string) => string;
  @Input() trackById!: (index: number, item: { id: number }) => number;
}
